/* eslint-disable no-loop-func */
import * as types from './types';
import * as contentTypes from '@/modules/content/store/types';
import * as templatesTypes from '@/modules/templates/store/types';
import * as rootTypes from '@/store/types';
// eslint-disable-next-line import/no-cycle
import campaignApi from '../api/campaignApi';
import helper from '@/core/helper';

const actions = {
  [types.FETCH_CAMPAIGNS]: (context, { params = {}, filters = {} }) => {
    if (!filters) return [];
    const {
      page, perPage, sortBy, sortDesc,
    } = params;
    const {
      search, states, advertiserId, accountManagerId,
    } = filters;
    const orderDirection = (sortDesc) ? 'DESC' : 'ASC';

    const queryParams = '?'.concat(
      page ? `&page=${page}&pageSize=${perPage}` : '',
      sortBy ? `&sortBy=${sortBy}&sortDirection=${orderDirection}` : '',
      search ? `&search=${encodeURIComponent(search)}` : '',
      states ? `&states=${states}` : '',
      advertiserId ? `&aid=${advertiserId}` : '',
      accountManagerId ? `&accountManagerId=${accountManagerId}` : '',
    );
    return campaignApi.getCampaigns(queryParams)
      .then((response) => response.campaigns);
  },
  [types.FETCH_ORDER]: (context, { advertiserId, campaignId, setOrder = false }) => campaignApi.getOrder(advertiserId, campaignId)
    .then((order) => {
      if (setOrder) context.commit(types.SET_ORDER, order);
      return order;
    }),
  [types.FETCH_CAMPAIGN_NAME_SEARCH]: (context, name) => campaignApi
    .getCampaigns(`?search=${encodeURIComponent(name)}`, context.rootState.account.advertiserId)
    .then(async (response) => response.campaigns),
  [types.FETCH_SELF_SERVICE_CAMPAIGN_NAME_SEARCH]: (context, name) => campaignApi
    .getSelfServiceCampaigns(`?search=${encodeURIComponent(name)}&type=SELF_SERVICE`)
    .then(async (response) => response.campaigns),
  [types.FETCH_CAMPAIGNS_SEARCH]: (context, { params = {}, filters = {} }) => {
    context.commit(types.SET_CAMPAIGNS, []);
    const accountAdvertiserId = context.rootState.account.advertiserId;
    if (accountAdvertiserId === null) {
      return [[], 0];
    }
    const {
      page, perPage, sortBy, sortDesc,
    } = params;
    const {
      search, states, advertiserId, accountManagerId,
    } = filters;
    const orderDirection = (sortDesc) ? 'DESC' : 'ASC';

    const queryParams = '?'.concat(
      page ? `&page=${page}&pageSize=${perPage}` : '',
      sortBy ? `&sortBy=${sortBy}&sortDirection=${orderDirection}` : '',
      search ? `&search=${encodeURIComponent(search)}` : '',
      states ? `&states=${states}` : '',
      advertiserId ? `&aid=${advertiserId}` : '',
      accountManagerId ? `&accountManagerId=${accountManagerId}` : '',
    );

    const checkCondition = (resolve, reject) => campaignApi
      .getCampaigns(queryParams, accountAdvertiserId)
      .then(async (response) => {
        const {
          total, campaigns,
        } = response;
        context.commit(types.SET_CAMPAIGNS, campaigns);
        const campaignsWithOrderData = await Promise.all(campaigns
          .map(async (campaignItem) => {
            const order = await campaignApi.getOrders(campaignItem.advertiserId, campaignItem.id);
            if (order.length === 0) {
              return {
                ...campaignItem,
              };
            }
            const {
              startDate, endDate, currencyId, budget,
            } = order[0];
            return {
              ...campaignItem,
              startDate: helper.parseISOString(startDate).getTime() / 1000,
              endDate: helper.parseISOString(endDate).getTime() / 1000,
              budget,
              currencyId,
            };
          }));
        const campaignIds = campaignsWithOrderData.map((item) => item.id).join(',');
        const multipleStats = campaignIds.length > 0 ? await campaignApi.getMultipleCampaignStats(campaignIds) : [];
        const campaignList = campaignsWithOrderData.map((item) => {
          const {
            impressions = '', clicks = '', ctr = '', budgetRemaining = '',
          } = multipleStats[item.id];
          return {
            ...item,
            impressions,
            clicks,
            ctr: ctr ? ctr.toFixed(2) : '',
            budgetRemaining,
          };
        });
        const payload = [campaignList, total];
        resolve(payload);
      })
      .catch((err) => {
        reject(err);
        return false;
      });
    return new Promise(checkCondition);
  },
  [types.FETCH_SELF_SERVICE_CAMPAIGNS]: (context, { params = {}, filters = {}, managed = false }) => {
    context.commit(types.SET_CAMPAIGNS, []);

    const {
      page, perPage, sortBy, sortDesc,
    } = params;
    const {
      search, states, advertiserId, accountManagerId,
    } = filters;
    const orderDirection = (sortDesc) ? 'DESC' : 'ASC';

    const queryParams = '?'.concat(
      page ? `&page=${page}&pageSize=${perPage}` : '',
      sortBy ? `&sortBy=${sortBy}&sortDirection=${orderDirection}` : '',
      '&type=SELF_SERVICE',
      search ? `&search=${encodeURIComponent(search)}` : '',
      states ? `&states=${states}` : '',
      advertiserId ? `&aid=${advertiserId}` : '',
      accountManagerId ? `&accountManagerId=${accountManagerId}` : '',
    );

    const checkCondition = (resolve, reject) => campaignApi
      .getSelfServiceCampaigns(queryParams, managed)
      .then(async (response) => {
        const {
          total, campaigns,
        } = response;
        context.commit(types.SET_CAMPAIGNS, campaigns);
        const campaignsWithOrderData = await Promise.all(campaigns
          .map(async (campaignItem) => {
            const order = await campaignApi.getOrders(campaignItem.advertiserId, campaignItem.id);
            if (order.length === 0) {
              return {
                ...campaignItem,
              };
            }
            const {
              startDate, endDate, currencyId, budget,
            } = order[0];
            return {
              ...campaignItem,
              startDate: helper.parseISOString(startDate).getTime() / 1000,
              endDate: helper.parseISOString(endDate).getTime() / 1000,
              budget,
              currencyId,
            };
          }));
        const campaignIds = campaignsWithOrderData.map((item) => item.id).join(',');
        const multipleStats = campaignIds.length > 0 ? await campaignApi.getMultipleCampaignStats(campaignIds) : [];
        const campaignList = campaignsWithOrderData.map((item) => {
          const {
            impressions = '', clicks = '', ctr = '', budgetRemaining = '',
          } = multipleStats[item.id];
          return {
            ...item,
            impressions,
            clicks,
            ctr: ctr ? ctr.toFixed(2) : '',
            budgetRemaining,
          };
        });
        const payload = [campaignList, total];
        resolve(payload);
      })
      .catch((err) => {
        reject(err);
        return false;
      });
    return new Promise(checkCondition);
  },
  [types.FETCH_EXISTING_ADVERTISERS]: (context, managed) => {
    const queryParams = managed !== undefined ? `?managed=${managed}` : '';

    const checkCondition = (resolve, reject) => {
      campaignApi.getAdvertisers(queryParams)
        .then((response) => {
          if (response.length !== 0 && (!context.state.selectedAdvertiser.id)) {
            context.commit(types.SET_ADVERTISERS, response);
            context.commit(types.SET_SELECTED_ADVERTISER, response[0]);
          }
          resolve(response);
        })
        .catch((err) => {
          context.commit(types.SET_IS_LOADING, false);
          reject(err);
        });
    };
    return new Promise(checkCondition);
  },
  [types.FETCH_ADVERTISER]: ({ commit }, advertiserId) => campaignApi
    .getAdvertiser(advertiserId)
    .then((advertiser) => {
      commit(types.SET_SELECTED_ADVERTISER, advertiser);
      return advertiser;
    })
    .catch(() => {
      commit(types.SET_IS_LOADING, false);
    }),
  [types.CREATE_ADVERTISER]: ({ commit }, advertiserName) => campaignApi
    .createAdvertiser(advertiserName)
    .then((advertiser) => {
      const newAdvertiser = [advertiser];
      commit(types.SET_ADVERTISERS, newAdvertiser);
      commit(types.SET_SELECTED_ADVERTISER, advertiser);
      return advertiser;
    })
    .catch(() => {
      commit(types.SET_IS_LOADING, false);
    }),
  [types.UPDATE_SELECTED_ADVERTISER]: (context, payload) => {
    context.commit(types.SET_SELECTED_ADVERTISER, payload);
  },
  [types.FETCH_EXISTING_CONTENT_PROVIDER]: (context) => {
    if (context.state.existingAdvertisers.length === 0) return false;
    const name = `${context.rootState.account.companyName}-${context.rootState.account.id}-${context.state.selectedAdvertiser.name}-${context.state.selectedAdvertiser.id}`;
    const checkCondition = (resolve, reject) => {
      campaignApi
        .getContentProvider(context.state.selectedAdvertiser.id)
        .then((response) => {
          if (response.length === 0) {
            const payload = {
              id: context.state.selectedAdvertiser.id,
              name,
              type: 'ADVERTISER',
            };
            campaignApi.createContentProvider(payload)
              .then((data) => {
                context.commit(types.SET_CONTENT_PROVIDER, data.id);
                context.commit(types.SET_CONTENT_PROVIDER_NAME, data.name);
                resolve(data);
              })
              .catch((err) => {
                reject(err);
                context.commit(types.SET_IS_LOADING, false);
              });
          } else {
            context.commit(types.SET_CONTENT_PROVIDER, response[0].id);
            context.commit(types.SET_CONTENT_PROVIDER_NAME, response[0].name);
            resolve(response);
            context.commit(types.SET_IS_LOADING, false);
          }
        })
        .catch((err) => {
          reject(err);
          context.commit(types.SET_IS_LOADING, false);
        });
    };
    return new Promise(checkCondition);
  },
  [types.CREATE_CAMPAIGN]: (context, payload) => {
    const campaignPayload = {
      advertiser: {
        id: context.state.selectedAdvertiser.id,
      },
      body: {
        name: payload.name,
        accountManagerUserId: payload.accountManagerUserId,
        salesUserId: payload.salesUserId,
        templateGroupId: payload.templateGroupId,
      },
    };
    if (payload.agencyId) {
      campaignPayload.body.agencyId = payload.agencyId;
    }
    return campaignApi.createCampaign(campaignPayload)
      .then((response) => {
        context.commit(types.SET_CAMPAIGN, response);
        return response;
      });
  },
  [types.CREATE_FEED]: ({ state, commit, rootState }) => {
    const feedName = `${rootState.account.companyName}-${rootState.account.id}-${state.campaign.id}`;
    return campaignApi.createFeed({
      id: state.selectedAdvertiser.id,
      contentProviderId: state.contentProviderId,
    }, feedName)
      .then((feed) => {
        commit(types.SET_CAMPAIGN_FEED, feed);
        commit(`content/${contentTypes.SET_FEED_ID}`, feed.id, { root: true });
        return feed;
      });
  },
  [types.PATCH_CAMPAIGN]: ({ state, commit }, payload) => campaignApi
    .patchCampaign({
      advertiserId: state.campaign.advertiserId,
      campaignId: state.campaign.id,
      ...payload,
    })
    .then((campaign) => {
      commit(types.SET_CAMPAIGN, campaign);
      commit(types.SET_CAMPAIGN_STATE, campaign.state);
      return campaign;
    }),
  [types.COPY_CAMPAIGN]: ({ commit }, payload) => campaignApi
    .copyCampaign(payload)
    .then((campaign) => {
      commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: `${campaign.name} has been created`,
        type: 'info',
      }, { root: true });
      return campaign;
    }),
  [types.REMOVE_CAMPAIGN]: ({ commit }, payload) => campaignApi
    .setCampaignAsDeleted(payload)
    .then((campaign) => {
      commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: `${payload.campaignName} has been deleted`,
        type: 'warning',
      }, { root: true });
      return campaign;
    }),
  [types.FETCH_CURRENCIES]: (context) => {
    campaignApi.getCurrencies()
      .then((currencies) => {
        const currencyMap = Object.fromEntries(Object
          .entries(currencies)
          // eslint-disable-next-line no-unused-vars
          .map(([key, { code, symbolString }]) => [code, symbolString]));
        context.commit(rootTypes.SET_CURRENCY_MAP, currencyMap, { root: true });
        context.commit(types.SET_CURRENCIES, currencies);
        return currencies;
      }).catch(() => {
        context.commit(types.SET_CURRENCIES, [{ id: 2, name: 'US Dollar', code: 'USD' }]);
      });
  },
  [types.SET_CAMPAIGN_STATE]: (context, payload) => {
    if (payload.isSelfServiceDashboard) {
      return campaignApi
        .setCampaignStateForSelfServiceDashboard(payload)
        .then((campaign) => campaign);
    }
    return campaignApi
      .setCampaignState(payload)
      .then((campaign) => {
        context.commit(types.SET_CAMPAIGN_STATE, campaign);
        return campaign;
      });
  },
  [types.SET_CAMPAIGN_LIVE]: (context, payload) => campaignApi
    .setCampaignLive(payload)
    .then((response) => response),
  [types.GET_CAMPAIGN_BY_ID]: (context, payload) => campaignApi
    .getCampaignNameById(payload)
    .then((campaign) => {
      context.commit(`content/${contentTypes.SET_CREATIVE_MODE}`, campaign.shareMode, { root: true });
      context.commit(types.SET_CAMPAIGN, {
        id: payload,
        ...campaign,
      });
      return campaign;
    }),
  [types.FETCH_CAMPAIGN_STATS_BY_ID]: (context, payload) => {
    if (helper.objLength(context.state.campaignStats) !== 0) return context.state.campaignStats;
    return campaignApi.getCampaignStatsById(payload)
      .then((stats) => context.commit(types.SET_CAMPAIGN_STATS, stats[payload]));
  },
  [types.GET_CAMPAIGN_BY_NAME]: (context, payload) => campaignApi
    .getCampaignByName(payload)
    .then((response) => response),
  [types.CREATE_ORDER]: (context, payload) => {
    const checkCondition = (resolve, reject) => {
      campaignApi.createOrder(context.state.selectedAdvertiser.id, payload)
        .then((order) => {
          context.commit(types.SET_ORDER, order);
          resolve(order);
        })
        .catch((err) => {
          reject(err);
        });
    };
    return new Promise(checkCondition);
  },
  [types.PATCH_ORDER]: (context, payload) => campaignApi
    .patchOrder(context.state.selectedAdvertiser.id, context.state.order.id, payload)
    .then((order) => {
      context.commit(types.SET_ORDER, order);
      return order;
    }),
  [types.PATCH_BLACKLIST]: (context, payload) => campaignApi
    .patchBlacklist(context.state.selectedAdvertiser.id, context.state.campaign.blacklistRuleSetId, payload)
    .then((blacklist) => {
      context.commit(types.SET_BLACKLIST, blacklist);
    }),
  [types.FETCH_BANNED_WORDS]: (context) => {
    campaignApi.getLinkingWords()
      .then((words) => {
        context.commit(types.SET_LINKING_WORDS, words);
        return words;
      });
  },
  [types.FETCH_COMMON_COUNTIES]: () => campaignApi.getCommonCounties()
    .then((counties) => counties),
  [types.FETCH_COUNTRIES]: (context) => {
    const checkCondition = (resolve, reject) => {
      campaignApi.getCountries()
        .then((response) => {
          const { countries, regions } = response;
          context.commit(types.SET_COUNTRIES, countries);
          context.commit(types.SET_REGIONS, regions);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    };
    return new Promise(checkCondition);
  },
  [types.FETCH_CAMPAIGN_STATES]: (context) => {
    const { states } = context.state;
    if (states && states.length > 0) return states;
    return campaignApi.getStates()
      .then((response) => {
        context.commit(types.SET_CAMPAIGN_STATES, response.data.states);
        return response.data.states;
      });
  },
  [types.DELETE_CAMPAIGN]: ({ state, commit }) => {
    if (state.campaign) {
      if (state.campaign.id) {
        campaignApi.deleteCampaign({
          advertiserId: state.selectedAdvertiser.id,
          campaignId: state.campaign.id,
        }).then(() => {
          commit(types.SET_CAMPAIGN, {});
        });
      }
    }
  },
  [types.DELETE_ORDER]: ({ state, commit }) => {
    if (state.order) {
      if (state.order.id) {
        campaignApi.deleteOrder({
          advertiserId: state.selectedAdvertiser.id,
          orderId: state.order.id,
        }).then(() => {
          commit(types.SET_ORDER, {});
        });
      }
    }
  },
  [types.DELETE_FEED]: ({ state, commit }) => {
    if (state.campaignFeedId) {
      campaignApi.deleteFeed({
        advertiserId: state.selectedAdvertiser.id,
        feedId: state.campaignFeedId,
      }).then(() => {
        commit(types.SET_CAMPAIGN_FEED, {});
      });
    }
  },
  [types.RESET_CAMPAIGN]: (context) => {
    context.commit(types.SET_CAMPAIGN, {});
    context.commit(types.SET_CAMPAIGN_FEED, {});
    context.commit(types.SET_ORDER, {});
    context.commit(types.SET_BLACKLIST, {});
    context.commit(types.SET_SELECTED_ADVERTISER, {});
    context.commit(types.SET_DEAL_OVERRIDES, []);
    context.commit(types.CLEAR_PUBLISHERS);
    context.commit(types.SET_CAMPAIGN_INFO_CHANGES, {});
    context.commit(`content/${contentTypes.SET_CONTENT_SCRAPE_ID}`, 0, { root: true });
    context.commit(`content/${contentTypes.SET_SCRAPED_CONTENT}`, [], { root: true });
    context.commit(`content/${contentTypes.NEW_SET_SCRAPED_CONTENT}`, [], { root: true });
    context.commit(`content/${contentTypes.NEW_SET_CONTENT_ITEMS}`, [], { root: true });
    if (context.rootState.content.inProgressContentScrapes.totalStartLength > 0
      || context.rootState.content.inProgressContentScrapes.contentItems.length > 0) {
      context.commit(`content/${contentTypes.SET_KILL_CURRENT_SCRAPING_FETCH}`, true, { root: true });
    }
    context.commit(`content/${contentTypes.RESET_CONTENT_ITEM}`, null, { root: true });
    context.commit(`content/${contentTypes.SET_CREATIVE}`, { id: 0 }, { root: true });
    context.commit(`content/${contentTypes.SET_CREATIVES}`, [], { root: true });
    context.commit(`templates/${templatesTypes.UPDATE_AVAILABLE_TEMPLATES}`, [], { root: true });
    context.commit(`templates/${templatesTypes.SET_SELECTED_TEMPLATES}`, [], { root: true });
  },
  [types.SUBMIT_CAMPAIGN]: (context) => campaignApi
    .submitCampaign(context.state.selectedAdvertiser.id, context.state.campaign.id)
    .then((response) => response)
    .catch((err) => err),
  [types.FETCH_EXISTING_CAMPAIGN]: (context, payload) => {
    const campaignPayload = {
      advertiserId: payload.advertiserId,
      campaignId: payload.campaignId,
    };
    return campaignApi.getCampaign(campaignPayload)
      .then((campaign) => {
        context.commit(types.SET_CAMPAIGN, campaign);
        return campaign;
      });
  },
  [types.UPDATE_PUBLISHERS_CREATIVES]: async (context, payload) => {
    const response = await campaignApi.patchPublishersCreative(payload);
    if (response.status !== 200) {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'We couldn\'t update the publishers\' creatives!',
        type: 'danger',
      }, { root: true });
    }
    return response;
  },
  [types.FETCH_EXISTING_BLACKLIST]: (context, blacklistRuleSetId) => campaignApi
    .getBlacklist(blacklistRuleSetId)
    .then((blacklist) => {
      context.commit(types.SET_BLACKLIST, blacklist);
      return blacklist;
    }),
  [types.FETCH_PUBLISHERS]: (context, payload) => campaignApi
    .getPublishers(payload)
    .then((publishers) => {
      context.commit(types.SET_PUBLISHER_LIST, publishers);
      return publishers;
    }),
  [types.FETCH_PUBLISHERS_GROUPS]: (context, type) => campaignApi
    .getPublisherGroups({ type })
    .then((groups) => groups.publisherGroups),
  [types.ADD_PUBLISHER]: ({ state, commit }, payload) => {
    if (state.publisherIds.indexOf(payload) === -1) {
      commit(types.SET_PUBLISHER, payload);
      return payload;
    }
  },
  [types.DELETE_PUBLISHER]: ({ state, commit }, payload) => {
    const itemToDeleteIndex = state.publisherIds.indexOf(payload);
    commit(types.REMOVE_PUBLISHER, itemToDeleteIndex);
  },
  [types.UPDATE_PUBLISHER_GROUP]: ({ commit }, payload) => {
    commit(types.SET_PUBLISHER_GROUPS, payload);
  },
  [types.FETCH_CREATIVE_SIZES]: () => campaignApi.getCreativeSizes()
    .then((templates) => templates),
  [types.FETCH_PUBLISHER_DEALS]: () => campaignApi.getPublisherDeals()
    .then((deals) => deals),
  [types.FETCH_ADX_ADVERTISERS]: (context) => {
    campaignApi.getAdxAdvertisers()
      .then((advertisers) => {
        context.commit(types.SET_ADX_ADVERTISERS, advertisers);
      });
  },
  [types.FETCH_DEAL_OVERRIDES]: ({ state, commit }) => campaignApi
    .getDealOverrides({
      advertiserId: state.selectedAdvertiser.id,
      orderId: state.order.id,
    })
    .then(({ deals }) => {
      commit(types.SET_DEAL_OVERRIDES, deals.filter((o) => (o.override)));
    }),
  [types.UPDATE_DEAL_OVERRIDES]: ({ commit }, payload) => {
    commit(types.SET_DEAL_OVERRIDES, payload);
  },
  [types.CREATE_DEAL_OVERRIDES]: ({ state }) => {
    const creativeDeals = state.dealOverrides
      .map((deal) => ({
        publisherId: Number(deal.publisherId),
        creativeId: Number(deal.creativeId),
        dealIdString: deal.dealIdString.trim(),
      }));
    campaignApi.postCreativeDealOverrides({
      advertiserId: state.selectedAdvertiser.id,
      body: {
        orderId: state.order.id,
        deals: creativeDeals,
      },
    }).then((res) => (res));
  },
  [types.SUBMIT_DEAL_OVERRIDES]: ({ state }) => {
    const creativeDeals = state.dealOverrides
      .map((deal) => ({
        publisherId: Number(deal.publisherId),
        creativeId: Number(deal.creativeId),
        dealIdString: deal.dealIdString.trim(),
      }));
    campaignApi.setCreativeDealOverrides({
      advertiserId: state.selectedAdvertiser.id,
      body: {
        orderId: state.order.id,
        deals: creativeDeals,
      },
    }).then((res) => (res));
  },
  [types.FETCH_AGENCIES]: (context) => campaignApi
    .getAgencies()
    .then((agencies) => {
      context.commit(types.SET_AGENCIES_LIST, agencies);
      return agencies;
    }),
  [types.CREATE_AGENCY]: ({ commit }, agencyName) => campaignApi
    .createAgency(agencyName)
    .then((agency) => {
      commit(types.SET_AGENCIES_LIST, agency);
      return agency;
    })
    .catch(() => {
      commit(types.SET_IS_LOADING, false);
    }),
  [types.GET_PUBLISHERS_CREATIVES]: (context, payload) => campaignApi.getPublishersCreative(payload)
    .then((response) => response),
  [types.SET_VIEW_TYPE]: (context, payload) => {
    context.commit(types.SET_VIEW_TYPE, payload);
  },
  [types.APPEND_TEMP_READ_ONLY_FEATURES]: (context, payload) => {
    context.commit(types.APPEND_TEMP_READ_ONLY_FEATURES, payload);
  },
  [types.SET_CAMPAIGN_INFO_CHANGES]: (context, payload) => {
    context.commit(types.SET_CAMPAIGN_INFO_CHANGES, payload);
  },
  [types.GET_CAMPAIGN_PROPERTIES]: (context, payload) => campaignApi.getCampaignProperties(payload)
    .then((response) => {
      context.commit(types.SET_CAMPAIGN_PROPERTIES, response.data.properties);
    }),
  [types.UPLOAD_LOGO_IMAGE]: (context, payload) => campaignApi.uploadCampaignLogo(payload)
    .then((response) => {
      context.commit(types.SET_CAMPAIGN_LOGO, response.logo);
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Master logo uploaded successfully',
        type: 'success',
      }, { root: true });
    }),
  [types.PATCH_CAMPAIGN_PROPERTIES]: (context, payload) => campaignApi.patchCampaignProperties(payload)
    .then((response) => {
      context.commit(types.SET_CAMPAIGN_PROPERTIES, response.properties);
    }),
  [types.DELETE_CAMPAIGN_LOGO]: (context, payload) => campaignApi.deleteLogo(payload)
    .then(() => {
      context.commit(types.DELETE_CAMPAIGN_LOGO);
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Master Logo deleted',
        type: 'success',
      }, { root: true });
    }),
};
export default actions;
